import { X } from "lucide-react";
import PropTypes from "prop-types";
import classnames from "classnames";

const WIDTH_CLASS = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-3xl"
};

const Drawer = ({ open, title, subtitle, onClose, width = "sm", children, footer }) => (
    <>
        <div
            className={classnames(
                "fixed inset-0 z-[200] bg-navy/60 backdrop-blur-[2px] transition-opacity duration-200",
                open ? "opacity-100" : "pointer-events-none opacity-0"
            )}
            onClick={onClose} />
        <div
            className={classnames(
                "fixed right-0 top-0 z-[201] flex h-full w-full flex-col bg-white shadow-2xl transition-transform duration-200 ease-out",
                WIDTH_CLASS[width],
                open ? "translate-x-0" : "translate-x-full"
            )}>
            <div className="flex items-center justify-between gap-3 border-b border-gray-200 px-5 py-4">
                <div>
                    <h2 className="text-base font-semibold text-gray-900">{title}</h2>
                    {subtitle && <p className="text-xs text-muted">{subtitle}</p>}
                </div>
                <button
                    type="button"
                    onClick={onClose}
                    className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600">
                    <X className="h-4.5 w-4.5" />
                </button>
            </div>

            <div className="flex-1 overflow-y-auto px-5">{children}</div>

            {footer && (
                <div className="flex items-center justify-between gap-3 border-t border-gray-200 bg-gray-50 px-5 py-4">
                    {footer}
                </div>
            )}
        </div>
    </>
);

Drawer.propTypes = {
    open    : PropTypes.bool.isRequired,
    title   : PropTypes.node.isRequired,
    subtitle: PropTypes.node,
    onClose : PropTypes.func.isRequired,
    width   : PropTypes.oneOf(["sm", "md", "lg", "xl"]),
    children: PropTypes.node,
    footer  : PropTypes.node
};

export default Drawer;
